import { ShoppingCart, ArrowRightLeft, Hourglass, CheckCircle2, ClipboardList } from "lucide-react";

export const historyMetadata = {
	compra: {
		title: "Historial de Compras",
		subtitle: "",
		breadcrumb: "Compras",
		icon: ShoppingCart,
		path: "/historiales/compra",
	},
	salida: {
		title: "Historial de Salidas",
		subtitle: "",
		breadcrumb: "Salidas",
		icon: ArrowRightLeft,
		path: "/historiales/salida",
	},
	en_uso: {
		title: "Productos En Uso",
		subtitle: "",
		breadcrumb: "En Uso",
		icon: Hourglass,
		path: "/historiales/en_uso",
	},
	usos: {
		title: "Historial de Usos",
		subtitle: "",
		breadcrumb: "Usos",
		icon: CheckCircle2,
		path: "/historiales/usos",
	},
	otros_movimientos: {
		title: "Otros Movimientos",
		subtitle: "",
		breadcrumb: "Otros Movimientos",
		icon: ClipboardList,
		path: "/historiales/otros_movimientos",
	},
};

export const getHistoryQuickActions = (currentType) => {
	return Object.entries(historyMetadata).map(([key, meta]) => ({
		key,
		label: meta.title,
		subtitle: meta.subtitle,
		Icon: meta.icon,
		isActive: currentType === key,
		path: meta.path,
	}));
};
